<template>
  <div class="main-template">
    <div v-if="loading">
      <!-- <v-icon class="mdi-spin">mdi-loading</v-icon> -->
      <v-progress-circular indeterminate size="32" width="3" color="blue"></v-progress-circular>
      Loading Report {{ reportTitle }}...
      <!-- <v-skeleton-loader
        class="mx-auto"
        :tile="true"
        max-width="90%"
        type="heading,table-tbody"
        !
        loading-text="Loading Report..." -->
      <!-- ></v-skeleton-loader> -->
    </div>
    <ReportTable
      v-if="reportReady"
      :fields="fields"
      :groupBy="groupBy"
      :summaryFields="summaryFields"
      :data="data"
      :headerData="headerData"
      :reportHeader="reportHeader"
      :summaryOnly="summaryOnly"
      :reportTitle="reportTitle"
    />
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
//
export default {
  name: "Report",
  components: {
    ReportTable: () => import("../components/ReportTable.vue")
    // VRuntimeTemplate,
  },
  props: {},
  data() {
    return {
      reportReady: false,
      loading: true,
      reportTitle: "",
      fields: [],
      summaryFields: {},
      groupBy: [],
      reportHeader: "",
      headerData: null,
      summaryOnly: false,
      data: []
    };
  },
  mounted() {
    var that = this;
    var dataObject = {
      object_name: "reports",
      // all_records: true,
      qry: { _id: this.$route.params.id }
    };
    axios
      .post(this.serverURL + "/get_data", dataObject, {
        withCredentials: true
      })
      .then(response => {
        var data = response.data.model[0];
        that.reportTitle = data.report_name;
        that.reportHeader = data.report_header;
        data.selected_report_fields = JSON.parse(data.selected_report_fields);
        try {
          data.selected_report_fields = JSON.parse(data.selected_report_fields);
        } catch (error) {
          //
        }

        that.summaryOnly = data.summary_only;
        Object.keys(data.selected_report_fields).forEach(f => {
          that.fields.push(f);
          if (data.selected_report_fields[f].summary && data.selected_report_fields[f].summary.includes("groupBy")) {
            that.groupBy.push(f);
          }
          if (data.selected_report_fields[f].summary && data.selected_report_fields[f].summary.length) {
            that.summaryFields[f] = {};
            data.selected_report_fields[f].summary.forEach(s => {
              that.summaryFields[f][s] = true;
            });
          }
        });
        var qry = {};
        var proj = {};
        this.fields.forEach(f => {
          qry[f] = { $exists: true };
          proj[f] = 1;
        });
        var dateQry = JSON.parse(localStorage.getItem("reportDatesQry"));
        var dateField = "converted_date";
        var dates = dateQry.dates;

        // Base match object
        var match = { ...qry };

        // 1. Parse assistant filters
        var assistantFilters = {};
        if (data.filters) {
          try {
            assistantFilters = JSON.parse(data.filters);
          } catch (e) {
            console.error("Invalid assistant filter JSON:", data.filters);
          }
        }

        // 2. Merge assistant filters
        Object.assign(match, assistantFilters);

        // 3. Add converted_date range using REAL Date objects
        match.converted_date = {
          $gte: new Date(fun.formatDate(dates[0], true) + "T00:00:00.000Z"),
          $lte: new Date(fun.formatDate(dates[1], true) + "T00:00:00.000Z")
        };
        match = this.makeInCaseInsensitive(match);
        // 4. Build pipeline exactly as before
        var pipeline = [
          {
            $addFields: {
              converted_date: {
                $ifNull: [
                  {
                    $dateFromString: {
                      dateString: "$" + dateQry.dateField,
                      onError: null
                    }
                  },
                  {
                    $dateFromString: {
                      dateString: "1/1/1800 00:00"
                    }
                  }
                ]
              }
            }
          },
          {
            $match: match
          }
          // { $project: proj },
        ];

        dataObject = {
          object_name: data.parent,
          all_records: true,
          // fields: this.fields,
          pipeline_date_fields: [dateField],
          pipeline: pipeline,
          qry: qry
        };
        axios
          .post(this.serverURL + "/get_data", dataObject, {
            withCredentials: true
          })
          .then(response => {
            this.loading = false;
            this.data = response.data.model;
            this.headerData = this.data[0];
            this.reportReady = true;
          });
      })
      .catch(r => {
        console.log(r);
        // this.$root.logout();
      });
  },
  beforeDestroy() {},
  methods: {
    makeInCaseInsensitive(match) {
      const expr = [];

      for (const [field, condition] of Object.entries(match)) {
        if (condition && typeof condition === "object" && Array.isArray(condition.$in)) {
          expr.push({
            $or: condition.$in.map(val => ({
              $regexMatch: {
                input: `$${field}`,
                regex: `^${val.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}$`,
                options: "i"
              }
            }))
          });

          delete match[field];
        }
      }

      if (expr.length) {
        match.$expr = { $and: expr };
      }

      return match;
    }
  }
};
</script>

<style lang="css" scoped></style>
